import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { Subscription, interval } from 'rxjs';
import { HttpClient } from '@angular/common/http'; // Import HttpClient
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  getMonthlyConditionOptions,
  getSegmentOptions,
  getmonths,
} from 'src/app/shared/helpers/Drop-down-options';
import { MonthlyReportService } from 'src/app/shared/service/monthly-report.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { MatSort, Sort } from '@angular/material/sort';

import { MatTableDataSource } from '@angular/material/table';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-old-reports',
  templateUrl: './old-reports.component.html',
  styleUrls: ['./old-reports.component.scss'],
})
export class OldReportsComponent implements OnInit, OnDestroy {
  monthoptions: any;
  filteredData: any;
  tableDataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatSort) sort!: MatSort;
  paginatedData: any[] = [];
  addRowdData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  filterForm!: FormGroup;
  segmentOptions: any;
  tableData: any[] = [];
  selectedTab: boolean;
  conditionOptions: any;
  addRowBtn: boolean = true;
  generateReport: boolean = false;
  private refreshSubscription!: Subscription;
  username: any;
  clientOptions: any ;
  subusername: any;
isLoadingTable: boolean = false;
  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private monthlyReportService: MonthlyReportService,
    private http: HttpClient,
    private overlayService: OverlapService,
  ) {
    this.selectedTab = true;
    this.filterForm = this.fb.group({
      year: ['', [Validators.required]],
      month: ['', [Validators.required]],
      segment: ['', [Validators.required]],
    });
    this.segmentOptions = getSegmentOptions();
    this.monthoptions = getmonths();
    this.conditionOptions = getMonthlyConditionOptions();
  }

  isClientMatch(customer: string, username: string): boolean {
    if (!customer || !username) return false;
    const c = customer.trim().toLowerCase();
    const u = username.trim().toLowerCase();
    if (c === u) return true;
    const mapping = ['eiger', 'elite', 'alcor', 'emz', 'ethiopian', 'zeronorth'];
    for (const key of mapping) {
      if (c.includes(key) && u.includes(key)) {
        return true;
      }
    }
    return false;
  }

  ngOnInit() {
    this.username = localStorage.getItem('username');
    this.subusername = localStorage.getItem('loginPic');
    this.selectedTab = true;
    if (this.subusername?.toLowerCase() === 'grace') {
      this.segmentOptions = ['Suezmax', 'LR3/Suezmax'];
    } else {
      this.segmentOptions = getSegmentOptions();
    }
    if (this.username !== 'Eiger Shipping') {
      this.getData();
    }
    this.loadClients();
  }
  loadClients(){
    this.requestFormService.getClientList().subscribe((res:any) =>{
       this.clientOptions = res.map((client:any) => client.client_name);
    })
  }

  getData() {
    this.isLoadingTable = true;
    this.monthlyReportService.getReportDetails().subscribe((data: any) => {
      let monthly = (data || []).filter(
        (item: any) => item.report_type === 'monthly'
      );

      if (this.username === 'Meraki - Operations') {
        this.tableData = monthly;
      } else {
        this.tableData = monthly.filter(
          (item: any) =>
            this.isClientMatch(item.customer, this.username) ||
            item.customer === 'Meraki - Operations' ||
            item.customer === 'Meraki Operation'
        );
      }

      // Grace user restriction: Suezmax only
      if (this.subusername?.toLowerCase() === 'grace') {
        this.tableData = this.tableData.filter((item: any) =>
          (item.segment || '').toLowerCase().includes('suezmax')
        );
        this.segmentOptions = Array.from(
          new Set(this.tableData.map((item: any) => item.segment).filter(Boolean))
        );
        if (this.segmentOptions.length === 0) {
          this.segmentOptions = ['Suezmax', 'LR3/Suezmax'];
        }
      }

      this.paginateData();
      this.isLoadingTable = false;
    });
  }

  ngOnDestroy() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.tableData.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  compare(a: any, b: any, isAsc: boolean, active: string): number {
    switch (active) {
      case 'year':
        return this.compareNumbers(a.report_year, b.report_year, isAsc);
      case 'month':
        return this.compareMonths(a.report_month, b.report_month, isAsc);
      default:
        return 0;
    }
  }

  compareNumbers(a: number, b: number, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareMonths(a: string, b: string, isAsc: boolean): number {
    const months = this.monthoptions; // Ensure this has month names in correct order
    const aIndex = months.indexOf(a);
    const bIndex = months.indexOf(b);
    return (aIndex < bIndex ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filterClick() {
    const from_date_str = this.filterForm.get('year')?.value;
    const to_date_str = this.filterForm.get('month')?.value;
    const segment = this.filterForm.get('segment')?.value;

    const filteredData = this.tableData.filter((element) => {
      const fromDateValid =
        !from_date_str || element.report_year === from_date_str;
      const toDateValid = !to_date_str || element.report_month === to_date_str;
      const segmentValid =
        !segment || element.segment?.toLowerCase() === segment.toLowerCase();

      return fromDateValid && toDateValid && segmentValid;
    });
    this.paginatedData = filteredData;
    console.log(filteredData);
  }

  clearClick() {
    this.filterForm.reset();
    this.getData();
  }

  pdfData: any;

  showDetails(row: any) {
    const baseUrl: string = environment.apiBaseUrl || window.location.origin;
    if (row.pdf_link) {
      this.pdfData = row.pdf_link;

      if (this.pdfData) {
        const fullUrl = baseUrl + this.pdfData;
        this.toastr.success(ToasterMessages.PdfProcessing);
        fetch(fullUrl)
          .then((response) => response.blob())
          .then((blob) => {
            this.overlayService.showPdf(blob);
            this.toastr.clear();
          })
          .catch((error) => {
            console.error('Error fetching PDF data:', error);
          });
      }
    } else {
      this.toastr.info('PDF not available');
    }
  }

  addRow() {
    const newRowSNo = this.paginatedData.length + 1;
    this.addRowdData.push({ sNo: newRowSNo });
    this.addRowBtn = false;
    this.generateReport = true;
  }

  generate(row: any) {
    const year = row.year;
    const monthIndex = this.monthoptions.indexOf(row.month);

    const startDate = new Date(year, monthIndex, 1);
    const endDate = new Date(year, monthIndex + 1, 0);

    const fromDate = this.formatDate(startDate);
    const toDate = this.formatDate(endDate);
    let payload = {
      from: fromDate,
      to: toDate,
      year: row.year,
      month: row.month,
      segment: row.segment,
      report_type: 'monthly',
      customer: row.client,
    };
    this.monthlyReportService.generateReport(payload).subscribe(
      (data: any) => {},
      (error) => {
        if (error.error.text === 'Responding: Process Triggered...') {
          this.toastr.success(ToasterMessages.MonthlyReportGenaration);
          this.clearClick();
          this.generateReport = false;
          this.addRowdData = [];
          this.getData();
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      },
    );
    this.addRowBtn = true;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = this.padZero(date.getMonth() + 1);
    const day = this.padZero(date.getDate());
    return `${year}-${month}-${day}`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }
  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, isAsc, sort.active);
    });
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
